var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href)?_c('p',{staticClass:"link",class:{ grey: _vm.isGrey }},[_c('a',{attrs:{"href":_vm.href}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])]):_c('p',{staticClass:"link",class:{ grey: _vm.isGrey },on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36965950","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TextLink.vue
// module id = null
// module chunks = 